module.exports = __webpack_public_path__ + "img/cockfight-menu-active-bg.0177ac1f.svg";